export default "__VITE_ASSET__5441ac9e__"